import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { clsx } from "clsx";
import styles from "./sk-Badge.module.css";
const iconSize = {
    medium: 16,
    large: 20,
};
export const Badge = ({ children, className, icon: Icon, isFaded = false, onBackground = "light", size = "medium", variant = "primary", ...restProps }) => {
    const mainClassNames = clsx(className, styles.main, {
        [styles[`main--${onBackground}`]]: !!onBackground,
        [styles[`main--${variant}`]]: !!variant,
        [styles[`main--${size}`]]: !!size,
        [styles[`main--withIcon`]]: !!Icon,
        [styles.isFaded]: isFaded,
    });
    return (_jsxs("span", { className: mainClassNames, ...restProps, children: [Icon && _jsx(Icon, { className: styles.icon, "aria-hidden": true, size: iconSize[size] }), _jsx("span", { className: styles.label, children: children })] }));
};
Badge.displayName = "Badge";
//# sourceMappingURL=Badge.js.map